import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGarlic: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="garlic"><path d="M14.5015 21.1662C19.7245 22.2257 21 18.307 21 15.5101C20.5823 9.71807 13.4211 7.7973 12.9474 2L10.1053 3.05405C11 8.92763 3 9.95395 3 16.4676C3 20.4132 6.31501 22.2 9.35963 21.0553M13.4211 10.9595C14.3684 13.0676 16.0915 19.8102 13.8502 21.0143C12.6693 21.6487 10.887 21.7187 9.77278 20.8814C8.26805 19.7459 8.68421 14.6486 9.63158 12.5405" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGarlic;
